import { html } from "../../base/_utils";
import staffModal from "./_staff-modal";

export default function staffCard(member, path) {
    return html`
        <div class="staff-card card border-0 bg-gray d-flex flex-column staff-detail-wrapper h-100">
            <img class="staff-img img-fluid" src="${path}${member.image}" />
            <div class="card-body p-4">
                <h3 class="staff-name font-primary-bold">
                    ${member.name.split(" ")[0]}<br />
                    ${member.name.split(" ")[1]}
                </h3>
                <hr class="bg-primary pt-1 mt-1 w-25 float-left" />
                <div class="clearfix"></div>
                <p class="staff-title font-primary-bold lead">${member.title}</p>
                ${member.phone ? html`<p class="mb-0 small"><a class="staff-phone link" href="tel:+1${member.phone}">${member.phone}</a></p>` : ""}
                ${member.phone ? html`<p class="mb-0 small"><a class="staff-email link" href="mailto:${member.email}">${member.email}</a></p>` : ""}
            </div>
            <div class="card-footer border-0 py-3 bg-primary text-center">
                <button class="staff-modal-trigger w-75 btn btn-block btn-secondary" data-bs-toggle="modal" data-bs-target="#${member.id}-modal">
                    <div class="top"></div>
                    <div class="text">
                        <div class="hover"></div>
                        VIEW BIO
                    </div>
                    <div class="bottom"></div>
                </button>
            </div>
        </div>
        ${staffModal(member, path)}
    `;
}
